import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { Box } from '@domain-group/suit-theme'

interface BulkAttachmentTileOverlayProps {
  isSelected: boolean,
}

const BulkAttachmentTileOverlay = (props: BulkAttachmentTileOverlayProps) => {
  const { isSelected } = props

  if (isSelected){
    return (
      <Box
        alignItems="center"
        borderRadius="50%"
        backgroundColor="blue"
        color="white"
        display="flex"
        height="auto"
        margin="medium"
        position="absolute"
        width="auto"
      >
        <FontAwesomeIcon icon={faCheckCircle} />
      </Box>
    )
  }

  return (
    <Box margin="medium" position="absolute">
      <FontAwesomeIcon color="white" icon={faCheckCircle} />
    </Box>
  )
}

export default BulkAttachmentTileOverlay
